// extracted by mini-css-extract-plugin
module.exports = {"form":"searchArtworks_form__hKHCi","clear":"searchArtworks_clear__dH5Nx","leftToRight":"searchArtworks_leftToRight__h91MM"};